const UTILS = {
  async PromisesSequential(PromiseArr) {
    let res = []
    for (let i = 0; i < PromiseArr.length; i++) {
      res.push(await PromiseArr[i])
    }
    return res
  },
  ConvertStringToHTML(str) {
    let parser = new DOMParser()
    let doc = parser.parseFromString(str, 'text/html')
    return doc.body
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script")
    script.text = str
    document.head.appendChild(script).parentNode.removeChild(script)
  },
  ObserveIntersection(elementSelector, config, callback) {
    let observer = new IntersectionObserver(callback, config);
    let node = typeof elementSelector == 'string' ? document.querySelector(elementSelector) : elementSelector
    observer.observe(node, config);  
    return observer;
  }
};

